import { z } from 'zod';

export const idSchema = z.object({
  annotator: z.string().nullable(),
  id: z.number(),
  link: z.string().nullable(),
  resource: z.string(),
  type: z.string(),
});
